import { IoMdClose } from 'react-icons/io';
import ModalWrapper from '../ModalWrapper';


export default function ErrorModal({ onClose, onRetry, message }) {

    return (
        <ModalWrapper onClose={onClose} showClose={false}>
            <div className="p-6 flex flex-col items-center justify-center gap-3">
                <div onClick={onClose} className='w-[120px] aspect-square rounded-full flex items-center justify-center bg-[rgba(52,168,83,0.05)]'>
                    <IoMdClose size color="rgba(249,0,0,0.55)" />
                </div>

                <p className="text-xl text-[#FF0000] font-semibold">{message}</p>
                {!!onRetry &&
                    <button
                        onClick={onRetry}
                        className='p-[14px] bg-customDark hover:bg-customDark/80 w-full max-w-[430px] rounded-[10px] text-xl font-outfit text-center'
                    >
                        Retry
                    </button>
                }
            </div>
        </ModalWrapper>
    );
}